module.exports = __webpack_public_path__ + "img/DN.6fc067f0.webp";